import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import PropTypes from "prop-types";
import React from "react";

export default function CardMeasure({ title, value, unit, time, valueColor }) {
  return (
    <Card variant="outlined" sx={{ borderRadius: "12px" }}>
      <CardContent sx={{ padding: "12px", height: "100%" }}>
        <Stack spacing={1}>
          <Typography
            variant="body2"
            color="#667085"
            sx={{ fontSize: "12px", fontWeight: 600 }}
          >
            {title}
          </Typography>

          <Stack direction="row" spacing={1} alignItems="baseline">
            <Typography
              variant="h4"
              sx={{ color: valueColor, fontWeight: 600, fontSize: "28px" }}
            >
              {value}
            </Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Typography
              variant="body2"
              color="#667085"
              sx={{ fontSize: "14px", fontWeight: 600 }}
            >
              {unit}
            </Typography>
            {time && (
              <Typography variant="caption" color="#667085" fontSize={10}>
                {format(new Date(time), "M/dd/yy p")}
              </Typography>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}

CardMeasure.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  unit: PropTypes.string.isRequired,
  time: PropTypes.string,
  valueColor: PropTypes.string,
};

CardMeasure.defaultProps = {
  time: undefined,
  valueColor: undefined,
};
